import { css, cva } from '@/styled-system/css';

/** Figma width with no matching size token. */
const TIP_CARD_WIDTH = '328px';

/** Below xl the tip card collapses into an Accordion under the step content. */
export const mobileContainerStyles = css.raw({
  display: { base: 'block', xl: 'none' },
});

export const desktopContainerStyles = css.raw({
  display: { base: 'none', xl: 'block' },
});

export const wizardTipCardRecipe = cva({
  base: {
    // oxlint-disable-next-line constellation/prefer-semantic-tokens -- ESLint's pandaLint set this warn-only; oxlint's oxlintPandaLint sets it error, no code change
    borderRadius: '{radii.300}',
  },
  variants: {
    isPremium: {
      true: {
        width: { base: '100%', xl: TIP_CARD_WIDTH },
        borderTop: '3px solid {colors.border.accent.brand.hero}',
      },
      false: {
        width: { base: '100%', xl: TIP_CARD_WIDTH },
      },
    },
  },
});
